var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEspath(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.331 10h2c.734 0 1.334.6 1.334 1.333v2c0 .734-.6 1.334-1.334 1.334h-2c-.733 0-1.333-.6-1.333-1.334v-2c0-.733.6-1.333 1.333-1.333z",
    fill: "#D5D5D5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.002 13.167H6.215a1.81 1.81 0 0 1-1.713-1.187 1.822 1.822 0 0 1 .506-2.027l5.327-4.66c.32-.28.327-.66.233-.92a.82.82 0 0 0-.78-.54H8.002a.504.504 0 0 1-.5-.5c0-.273.226-.5.5-.5h1.786a1.81 1.81 0 0 1 1.714 1.187c.273.72.073 1.514-.507 2.027l-5.327 4.66a.827.827 0 0 0-.233.92c.1.26.353.54.78.54h1.787c.273 0 .5.226.5.5 0 .273-.227.5-.5.5zM12.34 13a.669.669 0 0 1-.666-.666c0-.367.293-.667.667-.667h.006c.367 0 .667.3.667.667a.67.67 0 0 1-.673.666z",
    fill: "#979797"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.648 6a2.333 2.333 0 1 0 0-4.667 2.333 2.333 0 0 0 0 4.667z",
    fill: "#D5D5D5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.676 4.334a.669.669 0 0 1-.666-.667c0-.367.293-.667.666-.667h.007c.367 0 .667.3.667.667a.67.67 0 0 1-.674.667z",
    fill: "#979797"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEspath);
export default __webpack_public_path__ + "static/media/espath.ded06dc2ca9a386e9cca7f8ba4cd93ab.svg";
export { ForwardRef as ReactComponent };